export default {
  mainColor: 'Main color',
  secondaryColor: 'Secondary color',
  avatar: 'Avatar',
  avatarSize: 'Avatar size',
  avatarShape: 'Avatar shape',
  fontFamily: 'Font family',
  fontSize: 'Font size',
  jobSeparator: 'Job separator'
};
